import * as React from 'react';
import { observer } from 'mobx-react';
import { Alert } from '@payscale/design';
import { cycleRules } from 'utils/MobxDataManager/singletons';
import './unpublishedCycleAlert.scss';

export class UnpublishedCycleAlert extends React.Component {
    render(): React.ReactNode {
        if (!cycleRules.isCyclePendingAndUnpublishedCycleExists) {
            return null;
        }

        return (
            <Alert
                message={this.renderUnpublishedCycleMessage()}
                level="danger"
                close={true}
                className="nomst-unpublished-cycle-alert"
            />
        );
    }

    renderUnpublishedCycleMessage(): React.ReactNode {
        return (
            <div className="nomst-unpublished-cycle-alert__message">
                <strong>Your previous cycle has not been synced to Insight Lab.</strong>
                <p>
                    Previewing or opening a new cycle will override your previous cycle data.
                    Syncing the data to Insight Lab will ensure your employee data is current for your next cycle.
                </p>
            </div>
        );
    }
}

export default observer(UnpublishedCycleAlert);